// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// views
import { Menu, Badge } from "antd";
import Link from "next/link";

// utils
import { hasContactInfo } from "~/utils/user";

const UserProfileNavs = (props) => {
  const selectedKeys = [props.activeKey];

  return (
    <Menu
      mode="horizontal"
      selectedKeys={selectedKeys}
    >
      {props.user && (
        <Menu.Item key="info">
          <Badge dot={!hasContactInfo(props.user)}>
            <Link
              legacyBehavior
              href="/profile/info"
            >
              <a
                className="menu-link-item"
                style={{ fontSize: "16px" }}
              >
                个人信息
              </a>
            </Link>
          </Badge>
        </Menu.Item>
      )}
      <Menu.Item key="posts">
        <Link
          legacyBehavior
          href="/profile/posts"
        >
          <a className="menu-link-item">我的帖子</a>
        </Link>
      </Menu.Item>
      <Menu.Item key="replies">
        <Link
          legacyBehavior
          href="/profile/replies"
        >
          <a className="menu-link-item">我的评论</a>
        </Link>
      </Menu.Item>
      <Menu.Item key="views">
        <Link
          legacyBehavior
          href="/profile/views"
        >
          <a className="menu-link-item">历史记录</a>
        </Link>
      </Menu.Item>
      <Menu.Item key="marks">
        <Link
          legacyBehavior
          href="/profile/marks"
        >
          <a className="menu-link-item">我的收藏</a>
        </Link>
      </Menu.Item>
      <Menu.Item key="drafts">
        <Link
          legacyBehavior
          href="/profile/drafts"
        >
          <a className="menu-link-item">我的草稿</a>
        </Link>
      </Menu.Item>
    </Menu>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileNavs);
